import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class SiteBillingInsuranceShowRoute extends Route {
  @service store;
  @service router;

  async model(params) {
    const client = this.modelFor('site.billing.insurance');
    const insuranceInfo = await this.store.findRecord('insurance-info', params.id, {
      include: 'documents',
      reload: true,
    });

    if (insuranceInfo.client.id !== client.id) {
      this.router.transitionTo('not-found');
      return;
    }

    return { client, insuranceInfo };
  }
}
